module.exports = __webpack_public_path__ + "static/media/aquafury-logo.0ce15278.png";